import { camelToDash } from 'caseparser';
import controller from './kform-component.controller';
import template from './kform-component.html';
import kformUtils from '~/components/kform/utils/kform-utils';

const kformComponentDirective = /* @ngInject */ (
	/** @type {import('angular').translate.ITranslateService} */ $translate,
	/** @type {any} */ Notification,
) => ({
	replace:  true,
	restrict: 'E',
	scope:    {
		component:      '=',
		data:           '=',
		form:           '=',
		formName:       '=',
		index:          '=?',
		gridCol:        '=',
		gridRow:        '=',
		hideComponents: '=',
		options:        '=?',
		readOnly:       '=',
		submission:     '=ngModel',
	},
	require:  '^^?kform',
	template,
	link:     (
		/** @type {any} */ scope,
		/** @type {any} */ elements,
		/** @type {any} */ attributes,
		/** @type {any} */ kform,
	) => {
		/** @type {import('~/components/kform/kform.controller').default} */
		scope.formFieldClassName = `form-field-type-${camelToDash(scope.component.type)}`;
		scope.kform = kform;
		scope.showAlerts = (/** @type {any} */ alerts) => {
			try {
				alerts.message = (JSON.parse(alerts.message)).data;
			}
			// eslint-disable-next-line no-empty
			catch {}

			Notification.error({
				title:   $translate.instant('error.title'),
				message: alerts,
			});
		};
		scope.getStyle = (/** @type {any} */ component) => {
			const newStyle = { ...component.style };
			if (component.hidden) {
				newStyle.display = 'none';
			}
			return newStyle;
		};

		scope.isDisabled = (
			/** @type {any} */ component,
		) => scope.readOnly || component.disabled || (Array.isArray(scope.disableComponents)
			&& scope.disableComponents.includes(component.key));

		/**
		 * @param {any} component
		 * @param {any} row
		 * @returns {boolean}
		 */
		scope.isVisible = (component, row) => {
			if (scope.building) {
				return true;
			}
			return kformUtils.isVisible(
				component,
				row,
				scope.submission ? scope.submission.data : null,
				scope.hideComponents,
				scope.form,
			);
		}
	},
	controller,
});

export default kformComponentDirective;
